import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="card p-6 sm:p-10 space-y-6">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">{t('privacy.title', 'Privacy Policy')}</h1>

          <section className="space-y-3 text-gray-700 dark:text-gray-300 text-sm sm:text-base leading-relaxed">
            <p>{t('privacy.intro')}</p>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{t('privacy.collect_title')}</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('privacy.collect_1')}</li>
              <li>{t('privacy.collect_2')}</li>
              <li>{t('privacy.collect_3')}</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{t('privacy.use_title')}</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('privacy.use_1')}</li>
              <li>{t('privacy.use_2')}</li>
              <li>{t('privacy.use_3')}</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{t('privacy.security_title')}</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('privacy.security_1')}</li>
              <li>{t('privacy.security_2')}</li>
              <li>{t('privacy.security_3')}</li>
            </ul>

            <p>{t('privacy.footer')}</p>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default Privacy;
